import CustomerFooter from "@/components/customer-footer";
import PublicNotice from "@/modules/portfolio/ui/public-notice";
import PublicPageGrid from "@/modules/public-page/ui/public-page-grid";
import PublicPageStory from "@/modules/public-page/ui/public-page-story";
import type { PublicPageScreenView } from "@buildpy/core/views/g4b/public-page";

// 공개 링크 — 로그인 없음 · 링크마다 한 화면 · 검색 노출은 막지 않는다(D10 — noindex 는 접수 완료 화면에만).
const Page = ({ data }: { data: PublicPageScreenView }) => {
  if (data.kind === "notice") return <PublicNotice text={data.text} />;
  const footer = <CustomerFooter className="px-4" show={data.footer} />;
  const result = data.view;
  return result.layout === "STORY" ? (
    <PublicPageStory footer={footer} view={result} />
  ) : (
    <PublicPageGrid footer={footer} view={result} />
  );
};

export default Page;
